/** Shared Rossi / demo checkout lane — Dallas, TX → Austin, TX */
export const ROSSI_DEMO_LANE = {
  originAddress: "123 Test St",
  originCity: "Dallas",
  originState: "TX",
  originPostalCode: "75201",
  destAddress: "456 Test Ave",
  destCity: "Austin",
  destState: "TX",
  destPostalCode: "78701",
  weight: "500",
  freightClass: "70",
  handlingUnits: "1",
} as const;

export const ROSSI_DEMO_LANE_SUMMARY = "Dallas, TX 75201 → Austin, TX 78701";

export const DEMO_CARRIER_CODES = new Set(["ROSI_DEMO", "SHIPPEEK_DEMO"]);

export type RossiFallbackZipRate = {
  city: string;
  state: string;
  freightCost: number;
  costPerAdditionalPallet: number;
};

/** ZIPs Rossi demo / fallback rating supports (Texas demo lane + legacy KC metro). */
export const ROSSI_FALLBACK_ZIP_RATES: Record<string, RossiFallbackZipRate> = {
  "75201": { city: "Dallas", state: "TX", freightCost: 65, costPerAdditionalPallet: 6 },
  "76006": { city: "Arlington", state: "TX", freightCost: 65, costPerAdditionalPallet: 6 },
  "78701": { city: "Austin", state: "TX", freightCost: 65, costPerAdditionalPallet: 6 },
  "64002": { city: "Lees Summit", state: "MO", freightCost: 65, costPerAdditionalPallet: 6 },
  "64055": { city: "Independence", state: "MO", freightCost: 65, costPerAdditionalPallet: 6 },
  "64108": { city: "Kansas City", state: "MO", freightCost: 65, costPerAdditionalPallet: 6 },
  "64116": { city: "North Kansas City", state: "MO", freightCost: 65, costPerAdditionalPallet: 6 },
  "64153": { city: "Kansas City", state: "MO", freightCost: 65, costPerAdditionalPallet: 6 },
  "66101": { city: "Kansas City", state: "KS", freightCost: 65, costPerAdditionalPallet: 6 },
  "66202": { city: "Mission", state: "KS", freightCost: 65, costPerAdditionalPallet: 65 },
  "66210": { city: "Overland Park", state: "KS", freightCost: 65, costPerAdditionalPallet: 65 },
};
